<template>
  <div class="property_details">
    <div class="img_container" id="img-container">
      <img
        :src="property.previewImage"
        alt=""
        class="preview_img"
        @error="
          $event.target.src = `${baseUrl}/property-preview-images-web/default.svg`
        "
      />
    </div>
    <div class="p_content">
      <div class="p_content_cont">
        <h2 class="p_content_cont_name">
          {{ property.name }}
        </h2>
        <p class="p_content_cont_address">
          {{ property.location?.address }}
        </p>
      </div>
      <div class="p_content_admin">
        <img :src="brokerImage" alt="" class="p_content_admin_logo" />
        <p>
          {{ property?.name }}
        </p>
        <RiCheckboxCircleFill size="0.9rem" class="tick" />
      </div>
      <div class="p_content_views">
        {{ computeViews(property.views) }} Views |
        {{ computeListing(property.location?.createdAt) }}
      </div>
      <p
        class="p_content_desc"
        :title="property.description"
        @click.stop="isExpandDesc = !isExpandDesc"
        :class="{ expand: isExpandDesc }"
      >
        {{ property.description }}
      </p>
    </div>
  </div>
</template>
<script setup>
import moment from "moment";
import { RiCheckboxCircleFill } from "@remixicon/vue";
const props = defineProps({
  property: Object,
});

//variables
const isExpandDesc = ref(false);
const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL;
//computed
const brokerImage = computed(
  () =>
    props.property?.brokerIds?.[0]?.firmImage ||
    `${baseUrl}/property-preview-images-web/default.svg`
);

//methods

function computeViews(views) {
  if (views > 1000000) {
    return (views / 1000000).toFixed(1) + "M ";
  } else if (views > 1000) {
    return (views / 1000).toFixed(1) + "K ";
  } else {
    return views;
  }
}

function computeListing(time) {
  return moment(time).fromNow();
}
</script>
<style lang="scss" scoped>
.explore_details {
  max-width: 1400px;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  padding: 1rem 2.5rem 0.7rem 2.5rem;
  @include respond-below(sm) {
    padding: 1rem 0.2rem 1rem;
    gap: 0.8rem;
    flex-direction: column;
    width: 100%;
  }
  .img_container {
    max-width: 500px;
    width: calc(27vh * 1.78);
    height: 27vh;
    max-height: calc(500px / 1.78);
    border-radius: 10px;
    @media screen and (max-width: 1200px) {
      width: 40vw;
      height: calc(40vw / 1.78);
    }
    @include respond-below(sm) {
      max-width: 100%;
      width: 100%;
      height: 12.5rem;
    }
    .preview_img {
      background-color: rgba(255, 255, 255, 0.1);
      height: 100%;
      width: 100%;
      border: 1px solid rgba($color: $color-light, $alpha: 0.2);
      border-radius: inherit;
      &:hover {
        transform: scale(101%);
        transition: all 500ms ease-in-out;
      }
    }
  }
  .p_content {
    padding: 0.3rem;
    @include Elipsis(40vw);
    font-size: $text-xs;
    color: rgb(255, 255, 255, 0.7);
    @include respond-below(sm) {
      font-size: $text-xxs;
      width: 100%;
      @include Elipsis(80vw);
    }
    &_cont {
      &_name {
        line-height: 1.9rem;
        color: $color-light;
        font-weight: 400;
        font-size: $text-md;
        letter-spacing: 0.5px;
      }
      &_address {
        line-height: 18px;
        font-weight: 400;
        margin-top: 0.125rem;
        @include respond-below(sm) {
          margin-top: 0rem;
        }
      }
    }
    &_admin {
      padding: 0.75rem 0rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      @include respond-below(sm) {
        padding: 0.25rem 0rem;
      }
      img {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
      }
    }
    &_views {
      font-size: $text-xxs;
      margin: 0px 0px 8px;
      @include respond-below(sm) {
        margin: 0px 0px 4px;
      }
    }
    &_desc {
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
      @include Elipsis(80%);
      @include respond-below(sm) {
        line-height: 110%;
        max-width: 100%;
        width: 100%;
      }
      text-wrap: balance;
      @include primary-font($text-xxs, 400, rgb(255, 255, 255, 0.7));
      width: 40vw;
      &.expand {
        text-overflow: clip;
        line-clamp: unset;
        -webkit-line-clamp: unset;
      }
    }
    .p_content_admin_logo {
      background-color: white;
    }
  }
}
</style>
